import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m6.21 7.185 10.606 10.607-3.36 3.359a2 2 0 0 1-2.827 0L2.85 13.373a2 2 0 0 1 0-2.829z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.816 17.791 6.209 7.184l4.072-2.768a6.8 6.8 0 0 1 8.656.647 6.8 6.8 0 0 1 .647 8.656z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.225 11.025a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M6.209 7.184l-2.444-.277a3.5 3.5 0 0 0-2.543 1.022l-.216.216a.905.905 0 0 0 .019 1.28l1.517 1.517m14.274 6.849.277 2.444a3.5 3.5 0 0 1-1.022 2.543l-.216.216a.907.907 0 0 1-1.28-.019l-1.517-1.517M2.25 21.75h3m-1.5-1.5v3m-2.25-21h3M3 .75v3m17.25 13.5h3m-1.5-1.5v3"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M1.125 17.25a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m8.25-15a.375.375 0 0 1 0-.75m0 .75a.375.375 0 1 0 0-.75m11.25 21.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1)
  ]));
}
const interfaceShareSpaceShip = { render };
export {
  interfaceShareSpaceShip as default,
  render
};
//# sourceMappingURL=interface-share-space-ship.svg.js.map
